import React from 'react';

import { PrimaryButton, Loader } from '@crehana/ui';
import { useMediaQuery, useCountdown } from '@crehana/react-hooks';
import { getQueryParam, notEmpty } from '@crehana/utils';

import { useCheckoutContext } from '../Context';
import { isCardPaymentMethod } from '../utils';
import customTimer from '../utils/formatter/customTimer';

import { DegreeQuota } from '../types';

import DesktopHeader from './CheckoutDesktop/components/Header';
import MobileHeader from './CheckoutMobile/components/Header';
import CheckoutMobile from './CheckoutMobile';
import CheckoutDesktop from './CheckoutDesktop/CheckoutDesktop';

type CheckoutPagesProps = {
  isFetchingCheckoutItemDetail: boolean;
  isCallCenter: boolean;
};

export type PageProps = {
  selectedQuotaNumber: number;
  setSelectedQuotaNumber: React.Dispatch<React.SetStateAction<number>>;
  displayTimer: string;
  quotas?: DegreeQuota[];
  selectedQuota?: DegreeQuota | null;
  isCallCenter: boolean;
};

const CheckoutPages: React.FC<CheckoutPagesProps> = ({
  isFetchingCheckoutItemDetail,
  isCallCenter,
}) => {
  const { productData, checkoutProductDetail } = useCheckoutContext();

  const { timer, callCenter } = productData;

  const expirationDate = callCenter?.expirationDate || timer;
  const { hours, days, minutes, seconds, finished } = useCountdown(
    expirationDate ? new Date(expirationDate) : undefined,
  );
  const displayTimer =
    expirationDate && !finished
      ? customTimer({ days, hours, minutes, seconds })
      : '';

  const { selectedPaymentMethod } = useCheckoutContext();
  /** Begin  Degree quotas */
  const [selectedQuotaNumber, setSelectedQuotaNumber] = React.useState(1);
  const isSelectedCardPaymentMethod = isCardPaymentMethod(
    selectedPaymentMethod?.title || '',
  );
  const isDegreeQuota =
    getQueryParam('is_degree_quota') === 'true' && isSelectedCardPaymentMethod;
  const quotas = isDegreeQuota
    ? checkoutProductDetail?.degreeQuotas?.filter(notEmpty)
    : undefined;
  const selectedQuota = quotas?.find(
    quota => quota?.quotaNumber === selectedQuotaNumber,
  );
  /** End  Degree quotas */

  const pageProps: PageProps = {
    setSelectedQuotaNumber,
    selectedQuotaNumber,
    displayTimer,
    quotas,
    selectedQuota,
    isCallCenter,
  };

  const { matches: isDesktop } = useMediaQuery('md');

  if (isFetchingCheckoutItemDetail) {
    return (
      <div className="h-screen overflow-x-hidden bg-gray-lighter">
        <header className="md:hidden">
          <MobileHeader />
        </header>
        <header className="hidden md:block">
          <DesktopHeader />
        </header>

        <div className="flex items-center justify-center h-screen">
          <Loader />
        </div>
      </div>
    );
  }

  if (!checkoutProductDetail) {
    return (
      <div className="h-screen overflow-x-hidden bg-gray-lighter">
        <header className="md:hidden">
          <MobileHeader />
        </header>
        <header className="hidden md:block">
          <DesktopHeader />
        </header>
        <div className="hidden md:block">
          <div className="flex flex-col items-center justify-center h-screen">
            <p className="mb-24 font-body3">Ocurrió un error inesperado</p>

            <PrimaryButton
              size="xl"
              onClick={() => window.location.reload()}
              label="Recargar página"
            />
          </div>
        </div>
      </div>
    );
  }

  return isDesktop ? (
    <CheckoutDesktop {...pageProps} />
  ) : (
    <CheckoutMobile {...pageProps} />
  );
};

export default CheckoutPages;
